// home.js
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Fetch from '../../../../../core/util/core/Fetch';
import config from '../../../../config/config';
import Toast from '../../../../../core/components/core/Util/Toast/Toast';
import CustomList from '../Util/List/CustomList/CustomList'
import CustomListContainer from '../Util/List/CustomList/CustomListContainer'
import { loadData } from '../Util/List/CustomList/loadData';

import '../home/Home.css';

const Documentation = () => {
  const sessionSelector = useSelector((state) => { return state.core.session });
  const friendly_url = sessionSelector.pdc_project_friendly_url;

  const paths = {
    endpoint: config.endpoints.backend + 'portal/getallannouncements'
  }

  const list = {
    labelTitle: 'Comunicados',
    icon: 'fa-file-lines',
    canDownload: true,
    fieldToDownload: 'file',
    filter: {
      friendly_url
    },
    columns: [
      {
        name: 'announcement_category',
        label: 'Categoria de Comunicado'
      },
      {
        name: 'title',
        label: 'Título'
      },
      {
        name: 'announcement_code',
        label: 'Código'
      },
      {
        name: 'publish_date',
        label: 'Data de Publicação'
      }
    ]
  };

  return (
    <CustomListContainer
      canAdd={false}
      labelTitle={list.labelTitle}
      icon={list.icon}
      content={<CustomList list={{ ...list, ...paths }} />}
    />
  );
};

export default Documentation;
